var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formatter',{attrs:{"text":_vm.text}},[_vm._l((_vm.units),function(unit){return _c('template',{slot:unit},[_vm._v(_vm._s(_vm.$tc('{n} {unit}', _vm.duration[unit], { unit, n: _vm.duration[unit] })))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }